/**
 * themeColors.js - Todos los temas de color predefinidos
 * Adaptado de NewLnF/data/themeColors.ts para AdminConsole (JavaScript)
 */

export const themeColorOptions = [
  // CONSERVATIVE / PROFESSIONAL THEMES
  {
    id: "default",
    name: "Default Light",
    description: "Clean and professional light theme",
    family: "conservative",
    colors: {
      primary: "hsl(221.2 83.2% 53.3%)",
      secondary: "hsl(210 40% 96%)",
      accent: "hsl(210 40% 94%)",
      background: "hsl(0 0% 100%)",
      foreground: "hsl(222.2 84% 4.9%)",
      muted: "hsl(210 40% 96%)",
      mutedForeground: "hsl(215.4 16.3% 46.9%)",
      card: "hsl(0 0% 100%)",
      cardForeground: "hsl(222.2 84% 4.9%)",
      border: "hsl(214.3 31.8% 91.4%)",
      navbar: "hsl(0 0% 100%)",
      toolbar: "hsl(210 40% 98%)",
      header: "hsl(221.2 83.2% 53.3%)",
      paper: "hsl(0 0% 100%)",
      footer: "hsl(210 40% 96%)",
      destructive: "hsl(0 84.2% 60.2%)",
      destructiveForeground: "hsl(210 40% 98%)",
      ring: "hsl(221.2 83.2% 53.3%)",
      input: "hsl(214.3 31.8% 91.4%)",
      popover: "hsl(0 0% 100%)",
      popoverForeground: "hsl(222.2 84% 4.9%)",
    },
  },
  {
    id: "default-dark",
    name: "Default Dark",
    description: "Elegant dark theme optimized for reduced eye strain and night mode accessibility",
    family: "conservative",
    colors: {
      primary: "hsl(217.2 91.2% 59.8%)",
      secondary: "hsl(217.2 32.6% 17.5%)",
      accent: "hsl(217.2 32.6% 17.5%)",
      background: "hsl(222.2 84% 4.9%)",
      foreground: "hsl(210 40% 98%)",
      muted: "hsl(217.2 32.6% 17.5%)",
      mutedForeground: "hsl(215 20.2% 65.1%)",
      card: "hsl(222.2 84% 4.9%)",
      cardForeground: "hsl(210 40% 98%)",
      border: "hsl(217.2 32.6% 17.5%)",
      navbar: "hsl(222.2 84% 4.9%)",
      toolbar: "hsl(217.2 32.6% 17.5%)",
      header: "hsl(217.2 91.2% 59.8%)",
      paper: "hsl(222.2 84% 4.9%)",
      footer: "hsl(217.2 32.6% 17.5%)",
      destructive: "hsl(0 62.8% 30.6%)",
      destructiveForeground: "hsl(210 40% 98%)",
      ring: "hsl(217.2 91.2% 59.8%)",
      input: "hsl(217.2 32.6% 17.5%)",
      popover: "hsl(222.2 84% 4.9%)",
      popoverForeground: "hsl(210 40% 98%)",
    },
  },
  {
    id: "professional-slate",
    name: "Professional Slate",
    description: "Sophisticated slate theme for corporate environments",
    family: "conservative",
    colors: {
      primary: "hsl(215 25% 27%)",
      secondary: "hsl(215 16% 47%)",
      accent: "hsl(215 20% 65%)",
      background: "hsl(0 0% 100%)",
      foreground: "hsl(215 25% 27%)",
      muted: "hsl(215 20% 65%)",
      mutedForeground: "hsl(215 16% 47%)",
      card: "hsl(0 0% 100%)",
      cardForeground: "hsl(215 25% 27%)",
      border: "hsl(215 20% 65%)",
      navbar: "hsl(0 0% 100%)",
      toolbar: "hsl(215 20% 95%)",
      header: "hsl(215 25% 27%)",
      paper: "hsl(0 0% 100%)",
      footer: "hsl(0 0% 96%)",
      destructive: "hsl(0 84.2% 60.2%)",
      destructiveForeground: "hsl(210 40% 98%)",
      ring: "hsl(215 25% 27%)",
      input: "hsl(215 20% 65%)",
      popover: "hsl(0 0% 100%)",
      popoverForeground: "hsl(215 25% 27%)",
    },
  },
  {
    id: "minimal-gray",
    name: "Minimal Gray",
    description: "Ultra-clean minimal theme with subtle gray tones",
    family: "conservative",
    colors: {
      primary: "hsl(0 0% 20%)",
      secondary: "hsl(0 0% 96%)",
      accent: "hsl(0 0% 94%)",
      background: "hsl(0 0% 100%)",
      foreground: "hsl(0 0% 20%)",
      muted: "hsl(0 0% 96%)",
      mutedForeground: "hsl(0 0% 45%)",
      card: "hsl(0 0% 100%)",
      cardForeground: "hsl(0 0% 20%)",
      border: "hsl(0 0% 89%)",
      navbar: "hsl(0 0% 100%)",
      toolbar: "hsl(0 0% 98%)",
      header: "hsl(0 0% 20%)",
      paper: "hsl(0 0% 100%)",
      footer: "hsl(0 0% 96%)",
      destructive: "hsl(0 84.2% 60.2%)",
      destructiveForeground: "hsl(210 40% 98%)",
      ring: "hsl(0 0% 20%)",
      input: "hsl(0 0% 89%)",
      popover: "hsl(0 0% 100%)",
      popoverForeground: "hsl(0 0% 20%)",
    },
  },
  {
    id: "corporate-blue",
    name: "Corporate Blue",
    description: "Professional blue theme for business environments",
    family: "conservative",
    colors: {
      primary: "hsl(210 100% 40%)",
      secondary: "hsl(210 40% 96%)",
      accent: "hsl(210 40% 94%)",
      background: "hsl(0 0% 100%)",
      foreground: "hsl(210 40% 15%)",
      muted: "hsl(210 40% 96%)",
      mutedForeground: "hsl(210 20% 50%)",
      card: "hsl(0 0% 100%)",
      cardForeground: "hsl(210 40% 15%)",
      border: "hsl(210 40% 90%)",
      navbar: "hsl(0 0% 100%)",
      toolbar: "hsl(210 40% 98%)",
      header: "hsl(210 100% 40%)",
      paper: "hsl(0 0% 100%)",
      footer: "hsl(210 40% 96%)",
      destructive: "hsl(0 84.2% 60.2%)",
      destructiveForeground: "hsl(210 40% 98%)",
      ring: "hsl(210 100% 40%)",
      input: "hsl(210 40% 90%)",
      popover: "hsl(0 0% 100%)",
      popoverForeground: "hsl(210 40% 15%)",
    },
  },
  {
    id: "executive-charcoal",
    name: "Executive Charcoal",
    description: "Sophisticated charcoal theme for executive environments",
    family: "conservative",
    colors: {
      primary: "hsl(210 10% 25%)",
      secondary: "hsl(210 10% 90%)",
      accent: "hsl(210 10% 85%)",
      background: "hsl(0 0% 100%)",
      foreground: "hsl(210 10% 15%)",
      muted: "hsl(210 10% 90%)",
      mutedForeground: "hsl(210 10% 45%)",
      card: "hsl(0 0% 100%)",
      cardForeground: "hsl(210 10% 15%)",
      border: "hsl(210 10% 85%)",
      navbar: "hsl(0 0% 100%)",
      toolbar: "hsl(210 10% 95%)",
      header: "hsl(210 10% 25%)",
      paper: "hsl(0 0% 100%)",
      footer: "hsl(210 10% 90%)",
      destructive: "hsl(0 84.2% 60.2%)",
      destructiveForeground: "hsl(210 40% 98%)",
      ring: "hsl(210 10% 25%)",
      input: "hsl(210 10% 85%)",
      popover: "hsl(0 0% 100%)",
      popoverForeground: "hsl(210 10% 15%)",
    },
  },
  {
    id: "academic-navy",
    name: "Academic Navy",
    description: "Traditional navy theme perfect for educational institutions",
    family: "conservative",
    colors: {
      primary: "hsl(220 100% 25%)",
      secondary: "hsl(220 40% 95%)",
      accent: "hsl(220 40% 90%)",
      background: "hsl(0 0% 100%)",
      foreground: "hsl(220 40% 15%)",
      muted: "hsl(220 40% 95%)",
      mutedForeground: "hsl(220 20% 50%)",
      card: "hsl(0 0% 100%)",
      cardForeground: "hsl(220 40% 15%)",
      border: "hsl(220 40% 90%)",
      navbar: "hsl(0 0% 100%)",
      toolbar: "hsl(220 40% 98%)",
      header: "hsl(220 100% 25%)",
      paper: "hsl(0 0% 100%)",
      footer: "hsl(220 40% 95%)",
      destructive: "hsl(0 84.2% 60.2%)",
      destructiveForeground: "hsl(210 40% 98%)",
      ring: "hsl(220 100% 25%)",
      input: "hsl(220 40% 90%)",
      popover: "hsl(0 0% 100%)",
      popoverForeground: "hsl(220 40% 15%)",
    },
  },
  {
    id: "neutral-stone",
    name: "Neutral Stone",
    description: "Warm neutral theme with stone-inspired tones",
    family: "conservative",
    colors: {
      primary: "hsl(25 10% 35%)",
      secondary: "hsl(25 10% 92%)",
      accent: "hsl(25 10% 88%)",
      background: "hsl(0 0% 100%)",
      foreground: "hsl(25 10% 20%)",
      muted: "hsl(25 10% 92%)",
      mutedForeground: "hsl(25 10% 50%)",
      card: "hsl(0 0% 100%)",
      cardForeground: "hsl(25 10% 20%)",
      border: "hsl(25 10% 88%)",
      navbar: "hsl(0 0% 100%)",
      toolbar: "hsl(25 10% 96%)",
      header: "hsl(25 10% 35%)",
      paper: "hsl(0 0% 100%)",
      footer: "hsl(25 10% 92%)",
      destructive: "hsl(0 84.2% 60.2%)",
      destructiveForeground: "hsl(210 40% 98%)",
      ring: "hsl(25 10% 35%)",
      input: "hsl(25 10% 88%)",
      popover: "hsl(0 0% 100%)",
      popoverForeground: "hsl(25 10% 20%)",
    },
  },

  // PLAYFUL / ENGAGING THEMES
  {
    id: "lime-burst",
    name: "Lime Burst",
    description: "Energetic lime green theme perfect for creative learning environments",
    family: "playful",
    baseColor: "#DAEF68",
    colors: {
      primary: "hsl(73 85% 67%)",
      secondary: "hsl(73 30% 85%)",
      accent: "hsl(73 40% 80%)",
      background: "hsl(73 85% 67%)",
      foreground: "hsl(73 30% 15%)",
      muted: "hsl(73 20% 90%)",
      mutedForeground: "hsl(73 15% 40%)",
      card: "hsl(0 0% 100%)",
      cardForeground: "hsl(73 30% 15%)",
      border: "hsl(73 30% 85%)",
      navbar: "hsl(73 85% 67%)",
      toolbar: "hsl(73 40% 95%)",
      header: "hsl(0 0% 100%)",
      paper: "hsl(0 0% 100%)",
      footer: "hsl(73 30% 85%)",
      destructive: "hsl(0 84.2% 60.2%)",
      destructiveForeground: "hsl(210 40% 98%)",
      ring: "hsl(73 85% 67%)",
      input: "hsl(73 30% 85%)",
      popover: "hsl(0 0% 100%)",
      popoverForeground: "hsl(73 30% 15%)",
    },
  },
  {
    id: "lavender-dream",
    name: "Lavender Dream",
    description: "Soft purple theme that sparks creativity and imagination",
    family: "playful",
    baseColor: "#C0BAF2",
    colors: {
      primary: "hsl(248 70% 85%)",
      secondary: "hsl(248 30% 90%)",
      accent: "hsl(248 40% 85%)",
      background: "hsl(248 70% 85%)",
      foreground: "hsl(248 30% 20%)",
      muted: "hsl(248 20% 95%)",
      mutedForeground: "hsl(248 15% 45%)",
      card: "hsl(0 0% 100%)",
      cardForeground: "hsl(248 30% 20%)",
      border: "hsl(248 30% 90%)",
      navbar: "hsl(248 70% 85%)",
      toolbar: "hsl(248 40% 97%)",
      header: "hsl(248 30% 20%)",
      paper: "hsl(0 0% 100%)",
      footer: "hsl(248 30% 90%)",
      destructive: "hsl(0 84.2% 60.2%)",
      destructiveForeground: "hsl(210 40% 98%)",
      ring: "hsl(248 70% 85%)",
      input: "hsl(248 30% 90%)",
      popover: "hsl(0 0% 100%)",
      popoverForeground: "hsl(248 30% 20%)",
    },
  },
  {
    id: "mint-fresh",
    name: "Mint Fresh",
    description: "Refreshing mint green theme that energizes learning",
    family: "playful",
    baseColor: "#73D29E",
    colors: {
      primary: "hsl(152 55% 64%)",
      secondary: "hsl(152 30% 85%)",
      accent: "hsl(152 40% 80%)",
      background: "hsl(152 55% 64%)",
      foreground: "hsl(152 30% 20%)",
      muted: "hsl(152 20% 90%)",
      mutedForeground: "hsl(152 15% 40%)",
      card: "hsl(0 0% 100%)",
      cardForeground: "hsl(152 30% 20%)",
      border: "hsl(152 30% 85%)",
      navbar: "hsl(152 55% 64%)",
      toolbar: "hsl(152 40% 95%)",
      header: "hsl(152 55% 64%)",
      paper: "hsl(0 0% 100%)",
      footer: "hsl(152 30% 85%)",
      destructive: "hsl(0 84.2% 60.2%)",
      destructiveForeground: "hsl(210 40% 98%)",
      ring: "hsl(152 55% 64%)",
      input: "hsl(152 30% 85%)",
      popover: "hsl(0 0% 100%)",
      popoverForeground: "hsl(152 30% 20%)",
    },
  },
  {
    id: "warm-sand",
    name: "Warm Sand",
    description: "Cozy beige theme that creates a welcoming learning atmosphere",
    family: "playful",
    baseColor: "#BAA694",
    colors: {
      primary: "hsl(32 20% 66%)",
      secondary: "hsl(32 15% 85%)",
      accent: "hsl(32 20% 80%)",
      background: "hsl(32 20% 66%)",
      foreground: "hsl(32 20% 25%)",
      muted: "hsl(32 10% 90%)",
      mutedForeground: "hsl(32 10% 45%)",
      card: "hsl(0 0% 100%)",
      cardForeground: "hsl(32 20% 25%)",
      border: "hsl(32 15% 85%)",
      navbar: "hsl(32 20% 66%)",
      toolbar: "hsl(32 15% 95%)",
      header: "hsl(32 20% 66%)",
      paper: "hsl(0 0% 100%)",
      footer: "hsl(32 15% 85%)",
      destructive: "hsl(0 84.2% 60.2%)",
      destructiveForeground: "hsl(210 40% 98%)",
      ring: "hsl(32 20% 66%)",
      input: "hsl(32 15% 85%)",
      popover: "hsl(0 0% 100%)",
      popoverForeground: "hsl(32 20% 25%)",
    },
  },
  {
    id: "sky-blue",
    name: "Sky Blue",
    description: "Bright sky blue theme that inspires boundless possibilities",
    family: "playful",
    baseColor: "#81C2EC",
    colors: {
      primary: "hsl(202 70% 72%)",
      secondary: "hsl(202 30% 85%)",
      accent: "hsl(202 40% 80%)",
      background: "hsl(202 70% 72%)",
      foreground: "hsl(202 30% 20%)",
      muted: "hsl(202 20% 90%)",
      mutedForeground: "hsl(202 15% 40%)",
      card: "hsl(0 0% 100%)",
      cardForeground: "hsl(202 30% 20%)",
      border: "hsl(202 30% 85%)",
      navbar: "hsl(202 70% 72%)",
      toolbar: "hsl(202 40% 95%)",
      header: "hsl(202 70% 72%)",
      paper: "hsl(0 0% 100%)",
      footer: "hsl(202 30% 85%)",
      destructive: "hsl(0 84.2% 60.2%)",
      destructiveForeground: "hsl(210 40% 98%)",
      ring: "hsl(202 70% 72%)",
      input: "hsl(202 30% 85%)",
      popover: "hsl(0 0% 100%)",
      popoverForeground: "hsl(202 30% 20%)",
    },
  },
  {
    id: "bubblegum-pink",
    name: "Bubblegum Pink",
    description: "Fun pink theme that brings joy and excitement to learning",
    family: "playful",
    baseColor: "#FA9CC6",
    colors: {
      primary: "hsl(330 90% 80%)",
      secondary: "hsl(330 30% 90%)",
      accent: "hsl(330 40% 85%)",
      background: "hsl(330 90% 80%)",
      foreground: "hsl(330 30% 25%)",
      muted: "hsl(330 20% 95%)",
      mutedForeground: "hsl(330 15% 45%)",
      card: "hsl(0 0% 100%)",
      cardForeground: "hsl(330 30% 25%)",
      border: "hsl(330 30% 90%)",
      navbar: "hsl(330 90% 80%)",
      toolbar: "hsl(330 40% 97%)",
      header: "hsl(330 90% 80%)",
      paper: "hsl(0 0% 100%)",
      footer: "hsl(330 30% 90%)",
      destructive: "hsl(0 100% 40%)",
      destructiveForeground: "hsl(210 40% 98%)",
      ring: "hsl(330 90% 80%)",
      input: "hsl(330 30% 90%)",
      popover: "hsl(0 0% 100%)",
      popoverForeground: "hsl(330 30% 25%)",
    },
  },
  {
    id: "sunshine-yellow",
    name: "Sunshine Yellow",
    description: "Bright yellow theme that radiates positivity and energy",
    family: "playful",
    baseColor: "#FFCE00",
    colors: {
      primary: "hsl(50 100% 50%)",
      secondary: "hsl(50 30% 85%)",
      accent: "hsl(50 40% 80%)",
      background: "hsl(50 100% 50%)",
      foreground: "hsl(50 30% 20%)",
      muted: "hsl(50 20% 90%)",
      mutedForeground: "hsl(50 15% 40%)",
      card: "hsl(0 0% 100%)",
      cardForeground: "hsl(50 30% 20%)",
      border: "hsl(50 30% 85%)",
      navbar: "hsl(50 100% 50%)",
      toolbar: "hsl(50 40% 95%)",
      header: "hsl(50 100% 50%)",
      paper: "hsl(0 0% 100%)",
      footer: "hsl(50 30% 85%)",
      destructive: "hsl(0 84.2% 60.2%)",
      destructiveForeground: "hsl(210 40% 98%)",
      ring: "hsl(50 100% 50%)",
      input: "hsl(50 30% 85%)",
      popover: "hsl(0 0% 100%)",
      popoverForeground: "hsl(50 30% 20%)",
    },
  },
  {
    id: "periwinkle-blue",
    name: "Periwinkle Blue",
    description: "Soft periwinkle blue theme that promotes calm focus",
    family: "playful",
    baseColor: "#8F9BFF",
    colors: {
      primary: "hsl(232 100% 78%)",
      secondary: "hsl(232 30% 85%)",
      accent: "hsl(232 40% 80%)",
      background: "hsl(232 100% 78%)",
      foreground: "hsl(232 30% 20%)",
      muted: "hsl(232 20% 90%)",
      mutedForeground: "hsl(232 15% 40%)",
      card: "hsl(0 0% 100%)",
      cardForeground: "hsl(232 30% 20%)",
      border: "hsl(232 30% 85%)",
      navbar: "hsl(232 100% 78%)",
      toolbar: "hsl(232 40% 95%)",
      header: "hsl(232 100% 78%)",
      paper: "hsl(0 0% 100%)",
      footer: "hsl(232 30% 85%)",
      destructive: "hsl(0 100% 40%)",
      destructiveForeground: "hsl(0 0% 100%)",
      ring: "hsl(232 100% 78%)",
      input: "hsl(232 30% 85%)",
      popover: "hsl(0 0% 100%)",
      popoverForeground: "hsl(232 30% 20%)",
    },
  },

  // ACCESSIBILITY FOCUSED THEMES
  {
    id: "high-contrast-light",
    name: "High Contrast Light",
    description: "Maximum contrast light theme for enhanced accessibility",
    family: "accessibility",
    colors: {
      primary: "hsl(0 0% 0%)",
      secondary: "hsl(0 0% 95%)",
      accent: "hsl(0 0% 90%)",
      background: "hsl(0 0% 100%)",
      foreground: "hsl(0 0% 0%)",
      muted: "hsl(0 0% 95%)",
      mutedForeground: "hsl(0 0% 30%)",
      card: "hsl(0 0% 100%)",
      cardForeground: "hsl(0 0% 0%)",
      border: "hsl(0 0% 0%)",
      navbar: "hsl(0 0% 100%)",
      toolbar: "hsl(0 0% 98%)",
      header: "hsl(0 0% 0%)",
      paper: "hsl(0 0% 100%)",
      footer: "hsl(0 0% 95%)",
      destructive: "hsl(0 100% 40%)",
      destructiveForeground: "hsl(0 0% 100%)",
      ring: "hsl(0 0% 0%)",
      input: "hsl(0 0% 90%)",
      popover: "hsl(0 0% 100%)",
      popoverForeground: "hsl(0 0% 0%)",
    },
  },
  {
    id: "high-contrast-dark",
    name: "High Contrast Dark",
    description: "Maximum contrast dark theme for enhanced accessibility",
    family: "accessibility",
    colors: {
      primary: "hsl(0 0% 100%)",
      secondary: "hsl(0 0% 10%)",
      accent: "hsl(0 0% 15%)",
      background: "hsl(0 0% 0%)",
      foreground: "hsl(0 0% 100%)",
      muted: "hsl(0 0% 10%)",
      mutedForeground: "hsl(0 0% 70%)",
      card: "hsl(0 0% 0%)",
      cardForeground: "hsl(0 0% 100%)",
      border: "hsl(0 0% 100%)",
      navbar: "hsl(0 0% 0%)",
      toolbar: "hsl(0 0% 5%)",
      header: "hsl(0 0% 100%)",
      paper: "hsl(0 0% 0%)",
      footer: "hsl(0 0% 10%)",
      destructive: "hsl(0 100% 60%)",
      destructiveForeground: "hsl(0 0% 0%)",
      ring: "hsl(0 0% 100%)",
      input: "hsl(0 0% 15%)",
      popover: "hsl(0 0% 0%)",
      popoverForeground: "hsl(0 0% 100%)",
    },
  },
];

export const getThemesByFamily = (family) => {
  return themeColorOptions.filter((theme) => theme.family === family);
};

export const getDefaultThemeForFamily = (family) => {
  if (family === "conservative") {
    return themeColorOptions.find((theme) => theme.id === "default") || themeColorOptions[0];
  }
  if (family === "accessibility") {
    return themeColorOptions.find((theme) => theme.id === "high-contrast-light") || themeColorOptions[0];
  }
  return themeColorOptions.find((theme) => theme.family === "playful") || themeColorOptions[6];
};

export const isDefaultTheme = (themeId) => {
  return themeId === "default" || themeId === "default-dark";
};

export const getThemeById = (themeId) => {
  return themeColorOptions.find((theme) => theme.id === themeId) || themeColorOptions[0];
};

export const addTheme = (theme) => {
  if (!themeColorOptions.find((t) => t.id === theme.id)) {
    themeColorOptions.push(theme);
  }
};

